import { CycleFeedbackReport } from "@/components/reviews/CycleFeedbackReport";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

/** HR's cycle-wide feedback triage — EPIC-072. */
export function CycleFeedbackPage() {
  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: "Cycle Feedback" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Cycle Feedback"
        description="Every piece of written feedback in a round — filtered, themed, and triaged."
      />
      <CycleFeedbackReport />
    </div>
  );
}
